import React, { FC } from 'react'

const ThumbsUpOutlinedIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="14"
        height="12"
        viewBox="0 0 14 12"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M10.4382 12H3.431V4.32201L7.80745 0L8.11597 0.308516C8.17926 0.372266 8.23277 0.453699 8.27651 0.552815C8.32025 0.651931 8.34189 0.743136 8.34142 0.826431V0.936715L7.62737 4.32201H12.4785C12.7702 4.32201 13.0308 4.43695 13.2602 4.66682C13.4896 4.8967 13.6048 5.15752 13.6057 5.44928V6.30852C13.6057 6.37227 13.5988 6.4416 13.5848 6.51652C13.5699 6.5919 13.5508 6.66124 13.5276 6.72452L11.622 11.2427C11.5262 11.4577 11.3649 11.6375 11.1383 11.7822C10.9122 11.9274 10.6788 12 10.4382 12ZM4.129 11.302H10.4382C10.5364 11.302 10.6369 11.2752 10.7397 11.2217C10.8426 11.1682 10.921 11.0786 10.975 10.953L12.9077 6.41601V5.44928C12.9077 5.3241 12.8675 5.22127 12.787 5.14076C12.7065 5.06026 12.6036 5.02001 12.4785 5.02001H6.75976L7.56804 1.20754L4.129 4.62006V11.302ZM3.431 4.32201V5.02001H1.04175V11.302H3.431V12H0.34375V4.32201H3.431Z"
        />
    </svg>
)

export default ThumbsUpOutlinedIcon
